import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  credits: [],
  account: {},
  fetchingCredit: false,
  inviteFormErrors: null,
  fetchingAccount: false,
  fetchedAddCredit: false,
  fetchingAddCredit: false,
  fetchingInviteUser: false,
  fetchingRevokeCredit: false,
  fetchedUpdateAccount: false,
  fetchingUpdateAccount: false,
  fetchedInviteUserSuccess: false,
};

const customersReducer = createReducer(initialState)({
  // GET ACCOUNT
  [types.FETCH_ACCOUNT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAccount: true,
    };
  },
  [types.FETCH_ACCOUNT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      account: payload,
      fetchingAccount: false,
    };
  },
  [types.FETCH_ACCOUNT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingAccount: false,
    };
  },
  // GET CREDIT
  [types.FETCH_ACCOUNT_CREDIT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCredit: true,
    };
  },
  [types.FETCH_ACCOUNT_CREDIT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      credits: payload?.data,
      creditsPagination: payload?.pagination,
      fetchingCredit: false,
    };
  },
  [types.FETCH_ACCOUNT_CREDIT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingCredit: false,
    };
  },
  // UPDATE ACCOUT
  [types.FETCH_UPDATE_CUSTOMER_ACCOUNT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateAccount: true,
      fetchedUpdateAccount: false,
    };
  },
  [types.FETCH_UPDATE_CUSTOMER_ACCOUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      account: payload,
      fetchedUpdateAccount: true,
      fetchingUpdateAccount: false,
    };
  },
  [types.FETCH_UPDATE_CUSTOMER_ACCOUNT_FAILED]: (state) => {
    return {
      ...state,
      fetchedUpdateAccount: false,
      fetchingUpdateAccount: false,
    };
  },
  [types.RESET_UPDATE_ACCOUNT]: (state) => {
    return {
      ...state,
      fetchedUpdateAccount: false,
    };
  },
  // ADD CREDIT
  [types.FETCH_ADD_CREDIT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddCredit: true,
      fetchedAddCredit: false,
    };
  },
  [types.FETCH_ADD_CREDIT_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedAddCredit: true,
      fetchingAddCredit: false,
    };
  },
  [types.FETCH_ADD_CREDIT_FAILED]: (state) => {
    return {
      ...state,
      fetchedAddCredit: false,
      fetchingAddCredit: false,
    };
  },
  [types.RESET_ADD_CREDIT]: (state) => {
    return {
      ...state,
      fetchedAddCredit: false,
    };
  },
  // ADD NFC CARD
  [types.FETCH_ADD_NFC_CARD_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddNfcCard: true,
      fetchedAddNfcCard: false,
    };
  },
  [types.FETCH_ADD_NFC_CARD_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedAddNfcCard: true,
      fetchingAddNfcCard: false,
    };
  },
  [types.FETCH_ADD_NFC_CARD_FAILED]: (state) => {
    return {
      ...state,
      fetchedAddNfcCard: false,
      fetchingAddNfcCard: false,
    };
  },
  [types.RESET_ADD_NFC_CARD]: (state) => {
    return {
      ...state,
      fetchedAddNfcCard: false,
    };
  },
  // REVOKE CREDIT
  [types.FETCH_REVOKE_CREDIT_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRevokeCredit: true,
    };
  },
  [types.FETCH_REVOKE_CREDIT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingRevokeCredit: false,
    };
  },
  [types.FETCH_REVOKE_CREDIT_FAILED]: (state) => {
    return {
      ...state,
      fetchingRevokeCredit: false,
    };
  },
  // INVITE CUSTOMER
  [types.FETCH_INVITE_USER_REQUEST]: (state) => {
    return {
      ...state,
      fetchingInviteUser: true,
      fetchedInviteUserSuccess: false,
    };
  },
  [types.FETCH_INVITE_USER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingInviteUser: false,
      fetchedInviteUserSuccess: true,
    };
  },
  [types.FETCH_INVITE_USER_FAILED]: (state, { errors }) => {
    return {
      ...state,
      inviteFormErrors: errors,
      fetchingInviteUser: false,
      fetchedInviteUserSuccess: false,
    };
  },
  [types.RESET_INVITE_FORM_ERRORS]: (state) => {
    return {
      ...state,
      inviteFormErrors: null,
    };
  },
});

export default customersReducer;
